﻿<div class="login-shell">

  <!-- ============ Painel da marca ============ -->
  <aside class="brand-panel">
    <div class="brand-panel__inner">
      <img src="assets/image/Logotipo_TemAPI_SemFundo-02.png" class="brand-panel__logo" alt="TemAPI" />

      <h1 class="brand-panel__headline">
        Suas integrações,<br />um só fluxo.
      </h1>
      <p class="brand-panel__sub">
        Integração, automação e monitoramento de integrações em uma única plataforma.
      </p>

      <!-- Assinatura visual: o fluxo do próprio produto -->
      <svg class="brand-panel__flow" viewBox="0 0 420 260" fill="none" aria-hidden="true">
        <path class="flow-line" d="M40 60 H150 Q170 60 170 80 V120 Q170 140 190 140 H300" />
        <path class="flow-line flow-line--slow" d="M40 200 H120 Q140 200 140 180 V160 Q140 140 160 140 H300" />
        <path class="flow-line flow-line--fast" d="M300 140 H340 Q360 140 360 120 V100 Q360 80 380 80" />
        <g class="flow-node" transform="translate(40,60)"><circle r="9"/></g>
        <g class="flow-node" transform="translate(40,200)"><circle r="9"/></g>
        <g class="flow-node flow-node--hub" transform="translate(300,140)"><rect x="-14" y="-14" width="28" height="28" rx="8"/></g>
        <g class="flow-node" transform="translate(380,80)"><circle r="9"/></g>
      </svg>
    </div>
  </aside>

  <!-- ============ Painel do formulário ============ -->
  <main class="form-panel">
    <div class="form-card">

      <header class="form-card__header">
        <h2 class="form-card__title">Acesse sua conta</h2>
        <p class="form-card__hint" *ngIf="!show2FACodeInput && !showEmailPhone">
          Entre com suas credenciais da plataforma.
        </p>
        <p class="form-card__hint" *ngIf="showEmailPhone">
          Primeiro acesso: confirme seu e-mail e telefone para ativar a verificação em duas etapas.
        </p>
        <p class="form-card__hint" *ngIf="show2FACodeInput">
          Enviamos um código de verificação. Informe-o abaixo para continuar.
        </p>
      </header>

      <form nz-form nzLayout="vertical" [formGroup]="options"
            (ngSubmit)="signInWithEmail($event, false)" class="login-form">

        <nz-form-item>
          <nz-form-label nzFor="login-username">Usuário</nz-form-label>
          <nz-form-control nzErrorTip="Usuário é obrigatório.">
            <input nz-input id="login-username" placeholder="Seu usuário"
                   formControlName="username" autocomplete="username"
                   (focus)="firebaseErrorMessage=''" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzFor="login-password">Senha</nz-form-label>
          <nz-form-control [nzErrorTip]="passwordErrorTpl">
            <nz-input-group [nzSuffix]="passwordSuffix">
              <input nz-input id="login-password" placeholder="Sua senha"
                     formControlName="password" autocomplete="current-password"
                     [type]="hide ? 'password' : 'text'"
                     (focus)="firebaseErrorMessage=''" />
            </nz-input-group>
            <ng-template #passwordSuffix>
              <span nz-icon class="password-toggle"
                    [nzType]="hide ? 'eye-invisible' : 'eye'"
                    (click)="hide = !hide"
                    role="button" tabindex="0"
                    [attr.aria-label]="hide ? 'Mostrar senha' : 'Ocultar senha'"
                    (keydown.enter)="hide = !hide"></span>
            </ng-template>
            <ng-template #passwordErrorTpl let-control>
              <ng-container *ngIf="control.hasError('required')">Senha é obrigatória.</ng-container>
              <ng-container *ngIf="control.hasError('minlength')">Senha requer no mínimo 4 dígitos.</ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>

        <ng-container *ngIf="showEmailPhone">
          <nz-form-item>
            <nz-form-label nzFor="login-email">E-mail</nz-form-label>
            <nz-form-control [nzErrorTip]="emailErrorTpl">
              <input nz-input id="login-email" type="email" placeholder="voce@empresa.com"
                     formControlName="email" autocomplete="email"
                     (focus)="firebaseErrorMessage=''" />
              <ng-template #emailErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">E-mail é obrigatório.</ng-container>
                <ng-container *ngIf="control.hasError('email')">E-mail inválido.</ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label nzFor="login-phone">Telefone móvel com DDD</nz-form-label>
            <nz-form-control [nzErrorTip]="phoneErrorTpl">
              <input nz-input id="login-phone" type="tel" placeholder="(11) 99999-9999"
                     formControlName="phone" mask="(00) 00000-0000" [pattern]="pattern"
                     autocomplete="tel-national" inputmode="tel"
                     (focus)="firebaseErrorMessage=''" />
              <ng-template #phoneErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">Telefone é obrigatório.</ng-container>
                <ng-container *ngIf="control.hasError('pattern')">Informar um telefone móvel válido.</ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </ng-container>

        <ng-container *ngIf="show2FACodeInput">
          <nz-form-item>
            <nz-form-label nzFor="login-mfa">Código de verificação</nz-form-label>
            <nz-form-control nzErrorTip="Informe o código recebido.">
              <input nz-input id="login-mfa" class="mfa-input" placeholder="000000"
                     formControlName="mfaCode"
                     autocomplete="one-time-code" inputmode="numeric" maxlength="8" />
            </nz-form-control>
          </nz-form-item>
        </ng-container>

        <nz-alert *ngIf="formSubmitAttempt && firebaseErrorMessage"
                  nzType="error" [nzMessage]="firebaseErrorMessage"
                  nzShowIcon class="login-alert"></nz-alert>

        <button nz-button nzType="primary" nzSize="large" nzBlock
                class="submit-btn" type="submit"
                [nzLoading]="loading" [disabled]="disableButton()">
          {{ show2FACodeInput ? 'Verificar e entrar' : 'Entrar' }}
        </button>

        <button *ngIf="show2FACodeInput" nz-button nzType="default" nzSize="large" nzBlock
                class="resend-btn" type="button"
                (click)="signInWithEmail($event, true)">
          Reenviar código por SMS
        </button>

        <div class="login-actions">
          <button nz-button nzType="link" type="button" (click)="forgotPassword($event)">
            Esqueceu a senha?
          </button>
          <button nz-button nzType="link" type="button" (click)="openPolicy($event)">
            Política de Privacidade
          </button>
        </div>
      </form>
    </div>

    <footer class="form-panel__footer">
      © {{ currentYear }} TemAPI
    </footer>
  </main>
</div>